module.exports = __webpack_public_path__ + "static/img/KT-FH.c1c42b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/KT-FH.png
// module id = 7G6C
// module chunks = 1